import { createSelector } from 'reselect';
import { getBusinessDetails } from '@/selectors/merchant';
import { countrySpecificTranslationParser } from '@/selectors/utils';

export const getDefaultState = createSelector(getBusinessDetails, ({ subjectToVat, vatId }) => ({
  subjectToVat,
  vatId,
}));

export const translationParser = (state, { country }) => {
  return tKey => countrySpecificTranslationParser(state)(tKey, country);
};
